// extracted by mini-css-extract-plugin
export default {"structureAcl":"structureAcl___IL_dn","departmentNode":"departmentNode___h4Z7D"};